import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Astrologer_Register from '../auth/astrologer_register/Astrologer_Register'
import Home from '../components/pages/home/Home'
import User_Login from '../auth/user_login/User_Login'
import User_Register from '../auth/user_register/User_Register'
import User_Login_Otp_Verify from '../auth/user_login_otp_verify/User_Login_Otp_Verify'
import User_Register_Otp_Verify from '../auth/user_register_otp_verify/User_Register_Otp_Verify'
import User_DashBaord_DashBoard from '../components/pages/user_dashboard/user_dashbaord_dashboard/User_DashBaord_DashBoard'
import User_Dashboard_Profile from '../components/pages/user_dashboard/user_dashboard_profile/User_Dashboard_Profile'
import User_Dashboard_Orders from '../components/pages/user_dashboard/user_dashboard_orders/User_Dashboard_Orders'
import User_Dashboard_Wishlist from '../components/pages/user_dashboard/user_dashboard_wishlist/User_Dashboard_Wishlist'
import User_Dashboard_Address from '../components/pages/user_dashboard/user_dashboard_address/User_Dashboard_Address'
import User_Dashboard_Change_Password from '../components/pages/user_dashboard/user_dashboard_change_password/User_Dashboard_Change_Password'
import Protected_Routes from '../protected_routes/Protected_Routes'
import User_Dashboard_Logout from '../components/pages/user_dashboard/user_dashboard_logout/User_Dashboard_Logout'
import Protected_Routes_without_Login from '../protected_routes/Protected_Routes_without_Login'
import Product_Details from '../components/pages/product_details/Product_Details'
import Daily_Horoscope from '../components/pages/kundli/daily_horoscope/Daily_Horoscope'
import Daily_Horoscope_Details from '../components/pages/kundli/daily_horoscope_details/Daily_Horoscope_Details'
import User_Dashboard_Order_Details from '../components/pages/user_dashboard/user_dashbaord_order_details/User_Dashboard_Order_Details'
import User_dashbaord_Add_New_Address from '../components/pages/user_dashboard/user_dashboard_address/User_dashbaord_Add_New_Address'
import Wow_Animation from '../wow_animation/Wow_Animation'
import Astrologer_List from '../components/pages/astrologer/astrologer_list/Astrologer_List'
import Sub_Category_List from '../components/pages/category/sub_category_list/Sub_Category_List'
import Terms_Conditions from '../components/pages/terms_conditions/Terms_Conditions'
import Privacy_Policy from '../components/pages/privacy_policy/Privacy_Policy'
import Product_List from '../components/pages/product/Product_List'
import Cart from '../components/pages/cart/Cart'
import Order_Place from '../components/pages/order_place/Order_Place'
import Astrologer_Details from '../components/pages/astrologer/Astrologer_Details'
import Astrologer_Register_Otp_Verify from '../auth/astrologer_register_otp_verify/Astrologer_Register_Otp_Verify'
import Book_Pooja_List from '../components/pages/pooja/book_pooja_list/Book_Pooja_List'
import Astrologer_Profile from '../components/pages/astrologer/astrologer_profile/Astrologer_Profile'
import Astrologer_Login from '../auth/astrologer_login/Astrologer_Login'
import Astrologer_Home_Page from '../components/pages/astrologer/astrologer_home_page/Astrologer_Home_Page'
import Astrologer_Login_Otp_Verify from '../auth/astrologer_login_otp_verify/Astrologer_Login_Otp_Verify'
import Astro_Protected_Without_login from '../astro_protected_routes/Astro_Protected_Without_login'
import Book_Pooja_Details from '../components/pages/pooja/book_pooja_details/Book_Pooja_Details'
import Book_Pooja_Payment from '../components/pages/pooja/book_pooja_payment/Book_Pooja_Payment'

import Astrologer_New_Pooja_Process_List from '../components/pages/astrologer/astrologer_pooja_process/Astrologer_New_Pooja_Process_List'
import Astrologer_Pooja_Process from '../components/pages/astrologer/astrologer_pooja_process/Astrologer_Pooja_Process'
import Astrologer_Pooja_Complete_List from '../components/pages/astrologer/astrologer_pooja_process/Astrologer_Pooja_Complete_List'
import User_Dashboard_My_Pooja_List from '../components/pages/user_dashboard/user_dashbaord_my_pooja_list/User_Dashboard_My_Pooja_List'
import Astrologer_Save_Profile from '../components/pages/astrologer/astrologer_save_profile/Astrologer_Save_Profile'
import Astrologer_Save_Profile_Update from '../components/pages/astrologer/astrologer_save_profile/Astrologer_Save_Profile_Update'
import Astrologer_Calling_History from '../components/pages/astrologer/astrologer_calling_history/Astrologer_Calling_History'
import Astrologer_Privacy_Policy from '../components/pages/astrologer/astrologer_privacy_policy/Astrologer_Privacy_Policy'
import Astrologer_Terms_Conditions from '../components/pages/astrologer/astrologer_terms_condtions/Astrologer_Terms_Conditions'
import Astro_Protected_LoggedIn from '../astro_protected_routes/Astro_Protected_LoggedIn'
import Home_View_All_Product from '../components/pages/home_page_components/home_view_all_product/Home_View_All_Product'
import Home_Letest_Post_Details from '../components/pages/home_page_components/home_letest_post_details/Home_Letest_Post_Details'
import All_Letest_Post from '../components/pages/all_letest_post/All_Letest_Post'
import About_Us from '../components/pages/about_us/About_Us'
import Disclaimer from '../components/pages/disclaimer/Disclaimer'
import Astrotalk_Reviews from '../components/pages/astrotalk_reviews/Astrotalk_Reviews'


// important links
import { ImportantPageLayout } from '../components/pages/important_link_page/ImportantPageLayout'

import Add_Product_Review from '../components/pages/add_product_review/Add_Product_Review'
import User_Dashbaord_wallet from '../components/pages/user_dashboard/user_dashboard_wallet/User_Dashbaord_wallet'
import User_Dasboard_Wallet_Recharge from '../components/pages/user_dashboard/user_dasboard_wallet_recharge/User_Dasboard_Wallet_Recharge'
import User_Dashboard_Follow_List from '../components/pages/user_dashboard/user_dashboard_follow_list/User_Dashboard_Follow_List'
import Astrologer_Wallet from '../components/pages/astrologer/astrologer_wallet/Astrologer_Wallet'
import Astrologer_Bank_Deatils from '../components/pages/astrologer/astrologer_bank_details/Astrologer_Bank_Deatils'
import App_Privacy_Policy from '../components/pages/app_privacy_policy/App_Privacy_Policy'
import App_Terms_Condtion from '../components/pages/app_terms_condtion/App_Terms_Condtion'
import Add_Pooja_Review from '../components/pages/pooja/add_pooja_review/Add_Pooja_Review'
import Geo_Location from '../geo_location/Geo_Location'
// import Voice_Call from '../agora/agora_voice_call/Agora_Voice_Call'
import Page_Not_Found from '../page_not_found/Page_Not_Found'
// import Astrologer_Agora_Voice_Call from '../components/pages/astrologer/astrologer_agora_voice_call/Astrologer_Agora_Voice_Call'
// import Agora_Video_Call from '../agora/agora_video_call/Agora_Video_Call'
// import Agora_Chat from '../agora/agora_chat/Agora_Chat'
// import Astrologer_Agora_Chat from '../components/pages/astrologer/astrologer_agora_chat/Astrologer_Agora_Chat'
// import Zegocloud from '../zegocloud/Zegocloud'
import Astrologer_Live from '../components/pages/astrologer/astrologer_live/Astrologer_Live'
// import Zego_Cloud_Video_Call from '../zegocloud/Zego_Cloud_Video_Call'
// import Zego_Cloud_Room_Id_Video_Call from '../zegocloud/Zego_Cloud_Room_Id_Video_Call'
import Download_App from '../components/pages/download_app/Download_App'
import Astrologer_All_Call_History_List from '../components/pages/astrologer/astrologer_all_call_history_list/Astrologer_All_Call_History_List'
import Similar_Product_Details from '../components/pages/similar_product/Similar_Product_Details'
import Recommend_Gemstone from '../components/pages/recommend_gemstone/recommend_gemstone/Recommend_Gemstone'
import All_Shop_By_Collection from '../components/pages/home_page_components/home_shop by _collection/All_Shop_By_Collection'
import Collection_List from '../components/pages/collection/Collection_List'
import Custom_Jewelry from '../components/pages/custom-jewelry/Custom_Jewelry'
import All_Categories from '../components/pages/home_page_components/home_by_gemstone/All_Categories'
import Pooja from '../components/pages/pooja/pooja_main_page/Pooja'
import { Return_Policy } from '../components/pages/freeshipping_return_policy/Return_Policy'
import { ShippingPolicy } from '../components/pages/freeshipping_return_policy/ShippingPolicy'
import { Payment_Method } from '../components/pages/freeshipping_return_policy/Payment_Method'
import Pooja_Complete_Otp_Verify from '../auth/pooja-complete-otp-verify/Pooja_Complete_Otp_Verify'
import Pandit_Consultant from '../components/pages/astrologer/pandit_consultant/Pandit_Consultant'
import Withdrawal_History from '../components/pages/astrologer/wthdrawal_history/Withdrawal_History'
import Astrologer_Home_Call_History from '../components/pages/astrologer/astrologer_home_page/Astrologer_Home_Call_History'
import Astrologer_Home_Chat_History from '../components/pages/astrologer/astrologer_home_page/Astrologer_Home_Chat_History'
import Astrologer_All_Reviews_List from '../components/pages/astrologer/astrologer_reviews/Astrologer_All_Reviews_List'
import Pandit_List from '../components/pages/astrologer/pandit_list/Pandit_List'
import InvoicePage from '../components/common/invoice/Invoice'
import PoojainvoicePage from '../components/common/invoice/Poojainvoice'
import Allpoojacategory from '../components/pages/pooja/all_poojacategory/Allpoojacategory'
import Shubh_Muhurat from '../components/shubh_muhurat/Shubh_Muhurat'
import Pandit_Save_Profile from '../components/pages/astrologer/astrologer_save_profile/Pandit_Save_Profile'
import { Component } from 'lucide-react'
import Astrologer_Pooja_Cancel from '../components/pages/astrologer/astrologer_pooja_process/Astrologer_Pooja_cancel'

const AllRoutes = () => {
  return (
    <div>
      <Routes>
        {/* <-------- Routes of the Pages---------> */}
        <Route path='/' element={<Home />} />
        <Route path='/blog/:slug' element={<Home_Letest_Post_Details />} />
        <Route path='/blogs' element={<All_Letest_Post />} />
        <Route path='/about-us' element={<About_Us />} />
        <Route path='/disclaimer' element={<Disclaimer />} />
        <Route path='/astrotalk-reviews' element={<Astrotalk_Reviews />} />

        {/* subh muhurat route */}
        <Route path='/subh-muhurat/:slug' element={<Shubh_Muhurat />} />

        {/* important pages route */}
        <Route path='/page/:slug' element={<ImportantPageLayout />} />

        <Route path='/recommend-gemstone' element={<Recommend_Gemstone />} />

        {/* <--------- User Auth Section's ----------> */}
        <Route path='/user-login' element={<Protected_Routes Component={User_Login} />} />
        <Route path='/user-register' element={<Protected_Routes Component={User_Register} />} />
        <Route path='/user-login-otp-verify' element={<Protected_Routes Component={User_Login_Otp_Verify} />} />
        <Route path='/user-register-otp-verify' element={<Protected_Routes Component={User_Register_Otp_Verify} />} />

        {/* <------------ user Dashbaord section's --------------> */}
        <Route path='/user-dashBaord' element={<Protected_Routes_without_Login Component={User_DashBaord_DashBoard} />} />
        <Route path='/user-profile' element={<Protected_Routes_without_Login Component={User_Dashboard_Profile} />} />
        <Route path='/user-orders' element={<Protected_Routes_without_Login Component={User_Dashboard_Orders} />} />
        <Route path='/user-orders-details/:id' element={<Protected_Routes_without_Login Component={User_Dashboard_Order_Details} />} />
        <Route path='/user-wishlist' element={<Protected_Routes_without_Login Component={User_Dashboard_Wishlist} />} />
        <Route path='/user-address' element={<Protected_Routes_without_Login Component={User_Dashboard_Address} />} />
        <Route path='/user-add-new-address' element={<Protected_Routes_without_Login Component={User_dashbaord_Add_New_Address} />} />
        <Route path='/user-my-pooja-list' element={<Protected_Routes_without_Login Component={User_Dashboard_My_Pooja_List} />} />
        <Route path='/user-wallet' element={<Protected_Routes_without_Login Component={User_Dashbaord_wallet} />} />
        <Route path='/user-wallet-recharge' element={<Protected_Routes_without_Login Component={User_Dasboard_Wallet_Recharge} />} />
        <Route path='/user-logout' element={<Protected_Routes_without_Login Component={User_Dashboard_Logout} />} />
        <Route path='/add-product-review' element={<Protected_Routes_without_Login Component={Add_Product_Review} />} />
        <Route path='/edit-product-review' element={<Protected_Routes_without_Login Component={Add_Product_Review} />} />
        <Route path='/follow-list' element={<Protected_Routes_without_Login Component={User_Dashboard_Follow_List} />} />
        <Route path='/add-pooja-review' element={<Protected_Routes_without_Login Component={Add_Pooja_Review} />} />

        <Route path='/astrologer-list' element={<Astrologer_List />} />
        <Route path='/pandit-list' element={<Pandit_List />} />

        <Route path='/astrologer/:username' element={<Astrologer_Details />} />
        <Route path='/pandit/:username' element={<Astrologer_Details />} />

        {/* <--------- cart section's ----------> */}
        <Route path='/cart' element={<Protected_Routes_without_Login Component={Cart} />} />

        {/* <--------- category section's ----------> */}
        <Route path='/:slug' element={<Sub_Category_List />} />

        {/* <---------- Product Deatils ------------------------> */}
        <Route path='/product/:slug' element={<Product_Details />} />

        <Route path='/:categorySlug/:subCategorySlug' element={<Product_List />} />

        <Route path='/all-best-selling-product' element={<Home_View_All_Product />} />
        <Route path='/shop-by-collection' element={<All_Shop_By_Collection />} />
        <Route path='/all-categories' element={<All_Categories />} />

        {/* <--------- product policy section's ----------> */}
        <Route path='/return-policy' element={<Return_Policy />} />
        <Route path='/shipping-policy' element={<ShippingPolicy />} />
        <Route path='/payment-method' element={<Payment_Method />} />
        {/* <---------- Astrolger Auth section's ------------> */}
        <Route path='/astrologer-register' element={<Astrologer_Register />} />
        <Route path='/astrologer-register-otp-verify' element={<Astro_Protected_LoggedIn Component={Astrologer_Register_Otp_Verify} />} />
        <Route path='/astrologer-login-otp-Verify' element={<Astro_Protected_LoggedIn Component={Astrologer_Login_Otp_Verify} />} />
        <Route path='/astrologer-login' element={<Astrologer_Login />} />

        <Route path='/astrologer-profile' element={<Astro_Protected_LoggedIn Component={Astrologer_Profile} />} />
        <Route path='/pandit-profile' element={<Astro_Protected_LoggedIn Component={Astrologer_Profile} />} />
        <Route path='/astrologer-home' element={<Astro_Protected_Without_login Component={Astrologer_Home_Page} />} />
        <Route path='/pandit-home' element={<Astro_Protected_Without_login Component={Astrologer_Home_Page} />} />

        <Route path='/pandit-new-Pooja-process-list' element={<Astro_Protected_Without_login Component={Astrologer_New_Pooja_Process_List} />} />
        <Route path='/pandit-pooja-process' element={<Astro_Protected_Without_login Component={Astrologer_Pooja_Process} />} />
        <Route path='/pandit-pooja-complete-list' element={<Astro_Protected_Without_login Component={Astrologer_Pooja_Complete_List} />} />
        {/* astrologer pooja cancel */}
        <Route path='/pandit-pooja-cancel' element={<Astro_Protected_Without_login Component={Astrologer_Pooja_Cancel} />} />

        <Route path='/astrologer-save-profile' element={<Astro_Protected_Without_login Component={Astrologer_Save_Profile} />} />
        <Route path='/pandit-save-profile' element={<Astro_Protected_Without_login Component={Pandit_Save_Profile} />} />
        <Route path='/astrologer-all-call-history-list' element={<Astro_Protected_Without_login Component={Astrologer_All_Call_History_List} />} />
        <Route path='/pandit-all-call-history-list' element={<Astro_Protected_Without_login Component={Astrologer_All_Call_History_List} />} />
        {/* <Route path='/astrologer-chat-history' element={<Astro_Protected_Without_login Component={Astrologer_Home_Chat_History} />} /> */}
        {/* <Route path='/pandit-chat-history' element={<Astro_Protected_Without_login Component={Astrologer_Home_Chat_History} />} /> */}
        <Route path='/astrologer-all-reviews' element={<Astro_Protected_Without_login Component={Astrologer_All_Reviews_List} />} />
        <Route path='/pandit-all-reviews' element={<Astro_Protected_Without_login Component={Astrologer_All_Reviews_List} />} />

        <Route path='/astrologer-privacy-policy' element={<Astro_Protected_Without_login Component={Astrologer_Privacy_Policy} />} />
        <Route path='/pandit-privacy-policy' element={<Astro_Protected_Without_login Component={Astrologer_Privacy_Policy} />} />
        <Route path='/astrologer-terms-conditions' element={<Astro_Protected_Without_login Component={Astrologer_Terms_Conditions} />} />
        <Route path='/pandit-terms-conditions' element={<Astro_Protected_Without_login Component={Astrologer_Terms_Conditions} />} />
        <Route path='/astrologer-bank-details' element={<Astro_Protected_Without_login Component={Astrologer_Bank_Deatils} />} />
        <Route path='/pandit-bank-details' element={<Astro_Protected_Without_login Component={Astrologer_Bank_Deatils} />} />

        {/* <Route path='/astrologer_agora_voice_call' element={<Astro_Protected_Without_login Component={Astrologer_Agora_Voice_Call} />} /> */}
        {/* <Route path='/astrologer-agora-voice-call' element={<Astrologer_Agora_Voice_Call />} /> */}

        <Route path='/astrologer-save-profile-update' element={<Astrologer_Save_Profile_Update />} />
        <Route path='/pandit-save-profile-update' element={<Astrologer_Save_Profile_Update />} />
        <Route path='/astrologer-wallet' element={<Astrologer_Wallet />} />
        <Route path='/pandit-wallet' element={<Astrologer_Wallet />} />
        <Route path='/withdrawal-history' element={<Withdrawal_History />} />

        {/* <Route path='/astrologer-agora-chat' element={<Astro_Protected_Without_login Component={Astrologer_Agora_Chat} />} /> */}
        <Route path='/astrologer_live' element={<Astrologer_Live />} />

        <Route path='/custom-jewelry' element={<Custom_Jewelry />} />

        {/* <----------- kundli section's ----------------> */}
        {/* <Route path='/free-kundli' element={<Free_Kundli />} /> */}
        <Route path='horoscope/:slug' element={<Daily_Horoscope />} />
        <Route path='/daily-horoscope-details' element={<Daily_Horoscope_Details />} />

        <Route path='/collection/:slug' element={<Collection_List />} />

        {/* <------ Terms & condtion's and Privacy and policy page ---------> */}
        <Route path='/terms-conditions' element={<Terms_Conditions />} />
        <Route path='/privacy-policy' element={<Privacy_Policy />} />

        {/* <------- app Terms & Condtions and Privacy and Policy -------> */}
        <Route path='/app_privacy_policy' element={<App_Privacy_Policy />} />
        <Route path='/app_terms_conditions' element={<App_Terms_Condtion />} />

        {/* <--------- Order Place ---------------> */}
        <Route path='/order-place' element={<Order_Place />} />



        {/* <--------- Pooja section's -----------> */}
        <Route path='/pooja' element={<Pooja />} />
        <Route path='/all-pooja-category' element={<Allpoojacategory />} />

        <Route path='/pooja/:slug' element={<Book_Pooja_List />} />

        <Route path='/pooja-detail/:slug' element={<Book_Pooja_Details />} />
        <Route path='/pandit-consultant' element={<Pandit_Consultant />} />

        <Route path='/book-pooja-payment' element={<Protected_Routes_without_Login Component={Book_Pooja_Payment} />} />
        <Route path='/pooja-complete-otp-verify' element={<Protected_Routes Component={Pooja_Complete_Otp_Verify} />} />
        {/* <--------- Invoice --------> */}
        <Route path='/Invoice/:id' element={<Protected_Routes_without_Login Component={InvoicePage} />} />

{/* Pooja invoice */}
        <Route path='/pooja-invoice/:id' element={<Protected_Routes_without_Login Component={PoojainvoicePage} />} />
        {/* <--------- agora --------> */}
        <Route path='/Geo_Location' element={<Geo_Location />} />
        <Route path='/download-app' element={<Download_App />} />
        {/* <Route path='/Voice_Call' element={<Voice_Call />} /> */}
        {/* <Route path='/agora_video_call' element={<Agora_Video_Call />} /> */}
        {/* <Route path='/agora_chat' element={<Agora_Chat />} /> */}
        {/* <Route path='/zegocloud_livestream' element={<Protected_Routes_without_Login Component={Zegocloud} />} /> */}
        {/* <Route path='/zegocloud_video_call/:roomID' element={<Protected_Routes_without_Login Component={Zego_Cloud_Video_Call} />} /> */}
        {/* <Route path='/zego_cloud_room_id_video_call' element={<Protected_Routes_without_Login Component={Zego_Cloud_Room_Id_Video_Call} />} /> */}
        <Route path='/*' element={<Page_Not_Found />} />

      </Routes>
    </div>
  )
}

export default AllRoutes